import { SortModel } from '../../models';

export const toggleSortModel = (
  sortModel: SortModel[],
  field: string,
  shiftKey: boolean
): SortModel[] => {
  let newSort = [...sortModel];
  const existing = newSort.find(s => s.field === field);

  if (existing) {
    existing.order = existing.order === 'asc' ? 'desc' : 'asc';
  } else {
    if (!shiftKey) newSort = [];
    newSort.push({ field, order: 'asc' });
  }

  return newSort;
};
